export const APP_LOAD = 'APP_LOAD';
export const REDIRECT = 'REDIRECT';
export const REDIRECT2 = 'REDIRECT2';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED';
export const REGISTER_PAGE_UNLOADED = 'REGISTER_PAGE_UNLOADED';
export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';

export const API_BUILD_LOCAL_SEARCH = 'API_BUILD_LOCAL_SEARCH';
export const API_BUILD_LOCAL_RESET = 'API_BUILD_LOCAL_RESET';
export const API_BUILD_FOREIGN_SEARCH = 'API_BUILD_FOREIGN_SEARCH';
export const API_BUILD_FOREIGN_RESET = 'API_BUILD_FOREIGN_RESET';
export const API_BUILDER_LIMIT = 'API_BUILDER_LIMIT';
export const GET_SETTING = 'GET_SETTING';
export const UPDATE_SETTING = 'UPDATE_SETTING';

export const USERS = 'USERS';
export const USER_DELETE = 'USER_DELETE';
export const USER_CREATE = 'USER_CREATE';
export const USER_UPDATE = 'USER_UPDATE';
export const PASSWORD_UPDATE = 'PASSWORD_UPDATE';
export const REPORT = 'REPORT';
export const REPORT_RESET = 'REPORT_RESET';

export const CREATE_TWO_FACTOR = 'CREATE_TWO_FACTOR';
export const DOWNLOAD_TWO_FACTOR = 'DOWNLOAD_TWO_FACTOR';
export const UPDATE_TWO_FACTOR_STATUS = 'UPDATE_TWO_FACTOR_STATUS';



// WEBPACK FOOTER //
// src/constants/actionTypes.js